import { useEffect, useState } from 'react';
import { Location } from '@/models/location';

export const useGeolocation = () => {
  const [locationInfo, setLocationInfo] = useState<Location | null>(null);
  const [error, setError] = useState<GeolocationPositionError | null>(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError({
        code: 0,
        message: 'Geolocation is not supported',
        PERMISSION_DENIED: 1,
        POSITION_UNAVAILABLE: 2,
        TIMEOUT: 3,
      } as GeolocationPositionError);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (res) => {
        setLocationInfo({
          coords: {
            latitude: res.coords.latitude,
            longitude: res.coords.longitude,
          },
        });
      },
      (err) => {
        setError(err);
      }
    );
  }, []);

  return { locationInfo, error };
};
